import React, {useState, useEffect} from 'react';
import {IntegerField} from '../../libs/react-components-admin/fields/text-like-field';

const PaddingConfig = ({idPrefix, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  useEffect(() => { onChange(model); }, [model]);

  return <>
    <label className="form-label">Padding (in pixels, top, bottom , left, right)</label>
    <div className="row">
      <div className="col-12 col-md-3">
        <IntegerField id={(idPrefix || '') + 'padding-top'}
                      placeholder="Top"
                      value={model.top}
                      onChange={v => setModel({...model, top: v})}/>
      </div>
      <div className="col-12 col-md-3">
        <IntegerField id={(idPrefix || '') + 'padding-bottom'}
                      placeholder="Bottom"
                      value={model.bottom}
                      onChange={v => setModel({...model, bottom: v})}/>
      </div>
      <div className="col-12 col-md-3">
        <IntegerField id={(idPrefix || '') + 'padding-left'}
                      placeholder="Left"
                      value={model.left}
                      onChange={v => setModel({...model, left: v})}/>
      </div>
      <div className="col-12 col-md-3">
        <IntegerField id={(idPrefix || '') + 'padding-right'}
                      placeholder="Right"
                      value={model.right}
                      onChange={v => setModel({...model, right: v})}/>
      </div>
    </div>
  </>;
};

export default PaddingConfig;